import { Component, Input, OnDestroy, AfterViewInit, ViewChild } from '@angular/core';
import { CampaignStatistic, MsgOutBoxStatistics } from '../../../campaigns/campaign-statistic/campaign-statistic.component';
import { Router } from '@angular/router';
import { ShowCampaignMessageComponent, ShowMessage } from './show-campaign-message/show-campaign-message.component';


declare var $: any;

@Component({
  selector: 'individual-campaign-statistics',
  templateUrl: './individual-campaign-statistics.component.html',
  styleUrls: ['./individual-campaign-statistics.component.css']
})

export class IndividualCampaignStatisticsComponent implements AfterViewInit, OnDestroy {
  @Input()
  private statistic: CampaignStatistic = new CampaignStatistic();

  @ViewChild('showMsgModal', { static: false }) showMsgModal: ShowCampaignMessageComponent;

  private dataTable: any;
  private dtTable: any;
  private modalId: number = 0;

  constructor(private router: Router) { }

  ngAfterViewInit() {
    this.dataTable = $('#msgOutBoxStat-' + this.statistic.id);
    this.createDataTable();
  }


  private createDataTable() {
    let that = this;

    var dtOptions = {
      data: this.statistic.outboxes,
      columns: [
        {
          name: 'id',
          visible: false
        },
        {
          name: 'recepient'
        },
        {
          name: 'numberOfMessages',
          class: 'text-center',
          filterable: false,
        },
        {
          name: 'isSent',
          class: 'text-center',
          filterable: false,
          width: '70px',
          renderBoolAsCheckbox: true,
          boolTrueValue: true,
          boolFalseValue: false,
          useFalseIcon: true
        },
        {
          name: 'isError',
          class: 'text-center',
          filterable: false,
          width: '70px',
          renderBoolAsCheckbox: true,
          boolTrueValue: true,
          boolFalseValue: false,
          useFalseIcon: true
        },
        {
          name: 'failedCount',
          class: 'text-center',
          filterable: false
        },
        {
          name: 'errorReason',
          class: 'text-center',
          filterable: false
        },
        {
          name: 'isDelivered',
          class: 'text-center',
          filterable: false,
          width: '70px',
          renderBoolAsCheckbox: true,
          boolTrueValue: true,
          boolFalseValue: false,
          useFalseIcon: true
        },
        {
          name: 'deliveryTime',
          class: 'text-center',
          filterable: false
        },
        {
          name: 'numberOfLinks',
          class: 'text-center',
          filterable: false
        },
        {
          name: 'numberOfClickedLinks',
          class: 'text-center',
          filterable: false
        }
      ],
      rowButtons: {
        header: 'Options',
        dropdown: {
          text: '<i class="fas fa-ellipsis-v"></i>',
          class: '',
        },
        buttons: [{
          text: '<i class="far fa-envelope-open"></i> Show message',
          class: 'messagerow',
          dataAttributes: ['id'],
          action: function () {

          }
        }]
      },
    }

    this.dataTable.off('click', '.messagerow');

    this.dataTable.on('click', '.messagerow', function () {
      let id = parseInt($(this)[0].dataset.customId);
      that.showMsg(id, that.statistic.outboxes);
    });


    if (this.dtTable)
      this.dtTable.Destroy();

    this.dtTable = this.dataTable.LinkTable(dtOptions);
  }

  private showMsg(id: number, data: MsgOutBoxStatistics[]) {
    let showMessage = new ShowMessage();
    let message = data.find(x => x.id === id);
    
    if (message) {
      showMessage.id = message.id;
      showMessage.recepient = message.recepient;
      showMessage.content = message.body;

      this.showMsgModal.show(showMessage);
    }
  }

  private showStatistics(campaignId: number) {
    this.router.navigate(["/campaign/statistic"], { state: { data: { id: campaignId } } })
  }

  ngOnDestroy() {
    this.statistic = new CampaignStatistic();

    if (this.dtTable)
      this.dtTable.Destroy();
  }
}
